import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagLogisticaFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagLogistica'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          checked={iValue}
          disabled={fIsSubmitting}
          id='checkbox-flagLogistica'
          label='Logística'
        />
      )}
    </Field>
  )
}

export default React.memo(FlagLogisticaFormGroup)
